import { gql } from "@apollo/client";


export const EXISTE_NUMERO_SEGUIMIENTO = gql`
    query existNumeroSeguimiento( $idCliente: String!, $numeroSeguimiento: String!, $idPaciente: Int!){
        existNumeroSeguimiento( idCliente: $idCliente, numeroSeguimiento: $numeroSeguimiento, idPaciente: $idPaciente)
 }
`;